// src/App.js
import {
    useEffect,
    useState
} from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from 'react-router-dom';
import Home from './pages/Home';
import EmployeeDetail from './pages/EmployeeDetail';

export default function App() {
    return (
        <Router >
            <Routes >
                <Route
                    path="/"
                    element={< Home />} />
                <Route
                    path="/employee/:id"
                    element={< EmployeeDetail />} />
            </Routes>
        </Router>
    );
}